import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const KRRutinMeny: IRutinInfo[] = [
  rutinInfos.rtnKund,
  rutinInfos.rtnManuellInbetalning,
  rutinInfos.rtnBetalningsfiler,
  rutinInfos.rtnAterrappAgresso,
  rutinInfos.rtnUtbetalningtillgodohavande,
  rutinInfos.rtnKreditering,
  rutinInfos.rtnUtbetalningKreditfaktura,
  rutinInfos.rtnKundfakturaanalys,
  rutinInfos.rtnKundfakturahandelser,
  rutinInfos.rtnBeraknaTillgodoranta,
  rutinInfos.rtnKravutskrift,
  rutinInfos.rtnKravomgang,
  rutinInfos.rtnAutogirobet,
  rutinInfos.rtnAdresser_HarUtgatt,
  rutinInfos.rtnPostnr,
  rutinInfos.rtnAdressbokKontakter,
  rutinInfos.rtnLicenser,
  rutinInfos.rtnOrgPersLok,
];

export default KRRutinMeny;
